import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtBytes } from "@/lib/format";

// Compact per-user storage meter shown on the profile area (header) - fetches /api/me/storage.
export const StorageMeter = ({ className = "" }) => {
  const [s, setS] = useState(null);
  useEffect(() => {
    api.get("/me/storage").then((r) => setS(r.data)).catch(() => setS(null));
  }, []);
  if (!s) return null;
  if (s.unlimited) {
    return (
      <div className={`text-[10px] text-muted-foreground font-mono ${className}`} data-testid="storage-meter">
        {fmtBytes(s.used)} used · Unlimited
      </div>
    );
  }
  const warn = s.pct >= 90;
  return (
    <div className={className} data-testid="storage-meter" title={`Storage: ${fmtBytes(s.used)} of ${fmtBytes(s.quota)} used`}>
      <div className="flex items-center gap-1.5">
        <div className="w-20 h-1.5 rounded-full bg-accent overflow-hidden">
          <div className={`h-full rounded-full ${warn ? "bg-destructive" : "bg-primary"}`}
            style={{ width: `${Math.max(2, s.pct)}%` }} />
        </div>
        <span className={`text-[10px] font-mono ${warn ? "text-destructive" : "text-muted-foreground"}`} data-testid="storage-meter-text">
          {fmtBytes(s.used)} / {fmtBytes(s.quota)}
        </span>
      </div>
    </div>
  );
};
